/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manual_Qc_Type_OtherInputs */

const en_manual_qc_type_other = /** @type {(inputs: Manual_Qc_Type_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Other`)
};

const fr_manual_qc_type_other = /** @type {(inputs: Manual_Qc_Type_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Autre`)
};

const de_manual_qc_type_other = /** @type {(inputs: Manual_Qc_Type_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Andere`)
};

const it_manual_qc_type_other = /** @type {(inputs: Manual_Qc_Type_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Altro`)
};

const ru_manual_qc_type_other = /** @type {(inputs: Manual_Qc_Type_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Другой`)
};

const es_manual_qc_type_other = /** @type {(inputs: Manual_Qc_Type_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otro`)
};

const zh_cn2_manual_qc_type_other = /** @type {(inputs: Manual_Qc_Type_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`其他`)
};

const ja_manual_qc_type_other = /** @type {(inputs: Manual_Qc_Type_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`他の`)
};

const hi_manual_qc_type_other = /** @type {(inputs: Manual_Qc_Type_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अन्य`)
};

const pt_pt2_manual_qc_type_other = /** @type {(inputs: Manual_Qc_Type_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Outro`)
};

/**
* | output |
* | --- |
* | "Other" |
*
* @param {Manual_Qc_Type_OtherInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const manual_qc_type_other = /** @type {((inputs?: Manual_Qc_Type_OtherInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manual_Qc_Type_OtherInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_manual_qc_type_other(inputs)
	if (locale === "de") return de_manual_qc_type_other(inputs)
	if (locale === "it") return it_manual_qc_type_other(inputs)
	if (locale === "ru") return ru_manual_qc_type_other(inputs)
	if (locale === "es") return es_manual_qc_type_other(inputs)
	if (locale === "zh-CN") return zh_cn2_manual_qc_type_other(inputs)
	if (locale === "ja") return ja_manual_qc_type_other(inputs)
	if (locale === "hi") return hi_manual_qc_type_other(inputs)
	if (locale === "pt-PT") return pt_pt2_manual_qc_type_other(inputs)
	return en_manual_qc_type_other(inputs)
});